import { CargoContractSides } from '@shared/utils/constants';
import { CargoDetails } from '@api/features/cargos/getCargoDetails';
import { EditableCargo } from '@api/features/cargos/updateCargo';
import { UpdateCargoPort } from '@client/screens/estimates/details/context/hooks/useCargoHandlers';

export const SPLIT_BL_TOOLTIP = 'BL quantity is derived from a split BL on this cargo port. ' +
	'Please update BL quantity by either updating this BL split on the "Freight" tab, ' +
	'or undo the split to update the BL quantity directly';

export const isSyncedCargoKeyField = (
	fieldName: keyof EditableCargo,
) => (
	fieldName === 'quantity' ||
	fieldName === 'unit' ||
	fieldName === 'loadingPorts' ||
	fieldName === 'dischargePorts' ||
	fieldName === 'blNumber' ||
	fieldName === 'quantityTolerance' ||
	fieldName === 'quantityOption'
);

export const isSyncedCargoPortField = (
	fieldName: keyof UpdateCargoPort['attributes'],
) => (
	fieldName === 'cpQuantity' ||
	fieldName === 'secondaryCpQuantity' ||
	fieldName === 'blQuantity' ||
	fieldName === 'secondaryBlQuantity' ||
	fieldName === 'blDate' ||
	fieldName === 'idleDays'
);

export const getLinkedVcInCargo = (
	cargo: CargoDetails,
	cargos: CargoDetails[],
) => {
	return cargos.find((c) => (
		c.contractSide === CargoContractSides.VC_IN &&
		c.reletCargoId === cargo.id
	));
};
